export const BoLangues = {
  backOffice: {
    title: 'Back Office',
    user: {
      title: 'Liste des utilisateurs Back Office',
      column: {
        state: 'Etat',
        login: 'Login',
        name: 'Nom',
        firstName: 'Prénom',
        email: 'Email',
        dateConn: 'Date de Connexion',
      },
      fiche: {
        title: 'Fiche utilisateur',
        title_pwd: 'Mot de passe',
        title_pwd_edit: 'Modification de mot de passe',
        state: 'Etat',
        mail: 'Email',
        login: 'Login',
        firstName: 'Prénom',
        name: 'Nom',
        profil_user: 'Profil utilisateur',
        password: 'Mot de passe',
        passwordConfirm: 'Confirmation de mot de passe',
        errormail: "Votre email n'est pas valide",
        errorPasswrd: 'Le mot de pass est obligatoire',
        errorConfirmPass:
          'La confirmation du mot de passe est obligatoire et doit être valide',
      },
    },
    groupUser: {
      title: "Liste des groupes d'administrateurs",
      column: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        dateModif: 'Date de modification',
      },
    },
    profil: {
      fiche: {
        title: "Fiche du groupe d'administrateurs Groupe Super Administrateurs",
        titleModal: 'Ajouter un utilisateur',
        addProfile: {
          title: 'Accès Client',
          admin_account: 'Profil administrateur ',
          groupModal: 'Group :',
          userModal: 'Utilisateur',
          column: {
            client_name: 'Nom client',
            login: 'Login',
            mail: 'Mail',
            dateModif: 'Date de modification',
            dateCreation: 'Date de création',
          },
        },
      },
    },
    gestionGroup: {
      title: 'Liste des entités',
      column: {},
      fiche: {
        title: {
          creation: "Création d'un groupe",
          edit: 'Fiche du groupe {{code}}',
          label_module: 'Listes des modules',
          module: 'Module',
          placeholder_modul: '- Module -',
          to_prod_btn: 'Passer en prod',
        },
        modal_module: {
          title: 'Sélection Format',
          title_table: 'Liste des Modules',
          title_modale_add: "Ajout d'un module",
          title_modale_edit: "Modification d'un module",
          column: {
            module: 'Module',
            nb: 'Nombre',
            date: 'Date Création',
            user: 'User Backoffice',
          },
        },
      },
      administer: {
        title: 'Administration du groupe {{name}}',
        title_card: 'Contrôle de soldes en valeur',
        button_solde_value: 'Recalcul solde Valeur comptes sélectionnés',
        button_verification_value: 'Vérification Valeur',
        control_remise: 'Contrôle des Remises',
        control_valeur: 'Contrôle de solde en valeur',
        column: {
          state: 'Etat',
          code: 'Code',
          name: 'Nom',
          dateOP: 'Date Opération',
          soldeOP: 'Solde Opération',
          dateValue: 'Date Valeur',
          soldeValue: 'Solde Valeur',
        },
      },
      initialiser: {
        title: 'Initialisation du groupe {{name}}',
        title_filiale: 'Filiale',
        code: 'Code',
        name: 'Nom',
        list: 'Liste',
        first_title: 'Filiale',
        title_initialise: 'Initialisation des tables',
        label_initialise:
          'Création du Profil SuperAdministrator/Double Admin/Labels/4 Yeux/Catégorie',
        button_create: 'Création',
        title_create_format: 'Création Formats',
        title_import: 'Import Sociétés/Comptes',
        import_societe: 'Import Sociétés',
        import_compte: 'Import Comptes',
        title_imp_bank: 'Import Banques',
        title_beneficiaire: 'Import Bénéficiaires',
        title_mandant: 'Import Mandant',
        title_releve: 'Import relevé de compte',
        title_imp_treso: 'Import Plan Tréso',
        title_cpt_courant: 'Import Compte Courant',
        title_mvt: 'Import Mouvements de Comptes Courant',
        title_compta: 'Import Comptes Comptables',
        title_soc_tiers_compte:
          'Intégration Cubicus Script 1(Sociétés/Comptes/Users/Profils)',
        title_delete_tiers_compte:
          'Intégration Cubicus Script 2(Tiers/Groupe de Tiers)',
        title_tiers: 'Intégration Cubicus Script 3(Historique des lots)',
        title_histo: 'Import Historique',
        delete_script: 'Supprimer intégration Script 1',
        import_users: 'Import Utilisateurs',
        title_exodon: 'Intégration exodon',

        btn: {
          validate_btn: 'Valider',
          create_btn: 'Créer',
          import_btn: 'Importer',
        },
        modal_format: {
          title: 'Sélection Format',
          title_select: 'Groupe',
        },
      },
    },

    adminGenerale: {
      title: {
        admin: 'Administration Générale',
        controleBd: 'Contrôle BDD',
        controleAcces: 'Contrôle des Accès',
        controleLabs: 'Contrôle des Labels',
        controleWidgets: 'Contrôle des Widgets',
        controleChamp: 'Contrôle des Champs',
        integrationCubus: 'Intégration Cubicus',
        ebam: 'eBAM',
        selectGroup: 'Selectionner un groupe',
        renew_cert: 'Renouvellement Certificat HPB',
        select_hostId: 'Sélectionner le HOSTID',
        date: 'Date et heure de lancement',
      },
      btn: {
        admin: 'Administration',
        controleBd: 'Vérification BDD',
        controleAcces: 'Contrôle  Accès',
        controleLabs: 'Contrôle  Labels',
        controleWidgets: 'Contrôle Widgets',
        controleChamp: 'Contrôle Champs',
        ebam: 'eBAM',
        create_job: 'Créér le job',
      },
    },
    currency: {
      table: {
        title: 'Liste des Devises',
        DeviseISO: 'DeviseISO',
        label: 'Libellé',
        nb_decimal: 'Nombre décimal',
        code_cdf: 'Code BDF',
      },
      fiche: {
        title: 'Fiche Devise',
        currency: 'Devise',
        label: 'Nom',
      },
    },
    pays: {
      title: 'Liste des Pays Back Office',

      column: {
        name: 'Nom',
        dansSepa: 'DansSepa',
        dansFrance: 'DansFrance',
        iban: 'IBAN',
        devise: 'Devise',
        ssid: 'SISIDControl',
        codeP: 'Code pays',
      },
      fiche: {
        ficheTitle: 'Fiche du Pays',
        name: 'Nom',
        devise: 'Devise',
        dans_sepa: 'DansSepa',
        dans_france: 'DansFrance',
        iban: 'IBAN',
        SISIDControl: 'SISIDControl',
        code_pays: 'Pays Code',
        bbanRegex: 'Regex forme BBAN',
        bbanExample: 'Exemple BBAN',
        bbanRegexiban: 'Regex forme IBAN',
        bbanExampleiban: 'Exemple IBAN',
      },
    },
    codeOperation: {
      title: 'Liste des code opération Back Office',
      table: {
        column: {
          name: "Libellé d'origine",
          sense: 'Sense',
        },
      },
      fiche: {
        title: "Fiche d'un code Opération",
        code: 'Code',
        label: "Libellé d'origine",
        sense: 'Sense',
      },
    },
    audit: {
      title: 'Audit actions users',
      table_list: '- Table -',
      label_or_key: '- Label -',
      table: {
        column: {
          name: 'Nom de la table',
          key: 'Clé',
          date: 'Date',
          label: 'Libellé',
          login: 'Login',
        },
      },
      fiche: {
        title: 'Fiche code opération',
        code: 'Code',
        label: "Libellé d'origine",
        sense: 'Sense',
      },
    },
    releve_compte: {
      title: 'Relevés de compte',
      placeholder: '- Groupe -',
      detail_title: 'Détails relevés de compte {{name}}',
    },
  },
}

